import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Hero from '../UIComponents/Hero';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <Hero />
          <Container>
            <Row className="justify-content-sm-center">
              <Col xs={12} className="pb-4">
                <h1>Something went wrong.</h1>
              </Col>
            </Row>
          </Container>
        </>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;